if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        if (this.prevButton) this.prevButton.addEventListener('click', this.showPrevMedia.bind(this));
        if (this.nextButton) this.nextButton.addEventListener('click', this.showNextMedia.bind(this));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showPrevMedia();
          if (event.key === 'ArrowRight') this.showNextMedia();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]')).filter(
          (element) => element.parentElement === this.querySelector('.product-media-modal__content')
        );
      }

      showPrevMedia() {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        if (currentIndex === -1) return;
        const nextIndex = (currentIndex - 1 + items.length) % items.length;
        this.setActiveMediaElement(items[nextIndex]);
      }

      showNextMedia() {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        if (currentIndex === -1) return;
        const nextIndex = (currentIndex + 1) % items.length;
        this.setActiveMediaElement(items[nextIndex]);
      }

      setActiveMediaElement(activeMedia) {
        if (!activeMedia) return;
        this.querySelectorAll('[data-media-id].active').forEach((element) => {
          element.classList.remove('active');
        });
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        if (this.counterCurrent) {
          const items = this.getMediaItems();
          this.counterCurrent.textContent = items.indexOf(activeMedia) + 1;
        }
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMediaElement(activeMedia);
      }
    }
  );
}
